import { render, staticRenderFns } from "./AgentsOutstanding.vue?vue&type=template&id=8d80bae2&"
import script from "./AgentsOutstanding.vue?vue&type=script&lang=js&"
export * from "./AgentsOutstanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports